const KILO_BYTE = 1024;
const MEGA_BYTE = KILO_BYTE * 1024;
const GIGA_BYTE = MEGA_BYTE * 1024;
const TERA_BYTE = GIGA_BYTE * 1024;
const PETA_BYTE = TERA_BYTE * 1024;

export function formatBytes(bytes: number, decimals = 2): string {
  if (bytes === 0) {
    return '0 Bytes';
  }

  if (bytes < MEGA_BYTE) {
    const kiloBytes = bytes / KILO_BYTE;
    return kiloBytes.toFixed(decimals) + ' KB';
  }

  if (bytes < GIGA_BYTE) {
    const megaBytes = bytes / MEGA_BYTE;
    return megaBytes.toFixed(decimals) + ' MB';
  }

  if (bytes < TERA_BYTE) {
    const gigaBytes = bytes / GIGA_BYTE;
    return gigaBytes.toFixed(decimals) + ' GB';
  }

  if (bytes < PETA_BYTE) {
    const teraBytes = bytes / TERA_BYTE;
    return teraBytes.toFixed(decimals) + ' TB';
  }

  const petaBytes = bytes / PETA_BYTE;
  return petaBytes.toFixed(decimals) + ' PB';
}
